import React from 'react';
import { useTranslation } from 'react-i18next';
import { ClickableEmoji } from './ClickableEmoji';

interface EmojiSelectorProps {
  emojis: string[];
  onEmojiClick: (index: number) => void;
  selectedEmojis: boolean[];
  onSelectionChange: (newSelectedEmojis: boolean[]) => void;
}

const EmojiSelector: React.FC<EmojiSelectorProps> = ({
  emojis,
  onEmojiClick,
  selectedEmojis,
  onSelectionChange,
}) => {
  const { t } = useTranslation();
  const handleEmojiClick = (index: number) => {
    // Toggle the selected state of the clicked emoji
    const newSelectedEmojis = [...selectedEmojis];
    newSelectedEmojis[index] = !newSelectedEmojis[index];
    
    
    
    
    // Call the onSelectionChange prop with the new selection state
    onSelectionChange(newSelectedEmojis);
    
    // Call the onEmojiClick prop with the index of the clicked emoji
    // This is now called after onSelectionChange to ensure state is updated first
    onEmojiClick(index);
  };

  return (
    <div className="flex justify-between w-full mt-2 overflow-visible py-2">
      {emojis.map((emoji, index) => (
        <ClickableEmoji
          key={index}
          emoji={emoji}
          isSelected={selectedEmojis[index]}
          onClick={() => handleEmojiClick(index)}
          ariaLabel={`Select emoji: ${emoji}`}
          {...(emoji === '❓' ? {
            label: t('search.unknownLabel', 'Unknown'),
            title: t('search.unknownTooltip', 'Filter restaurants with no inspection score'),
          } : {})}
        />
      ))}
    </div>
  );
};

export default EmojiSelector;
